import type { AxiosProgressEvent, CancelToken } from "axios";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IFacultyImage } from "./routeType";

const { getPath } = getApi("faculties.image.post");

type IExtractedRouteType = IFacultyImage["facultyImageSingleUpload"];

export type IPostFacultyImage = IPickMutation<IExtractedRouteType>;

// const postFacultyImage: MutationFunction<
//   IPostFacultyImage["response"],
//   IPostFacultyImage["variables"]
// > = ({ facultyId, ...data }) => {
//   return axiosClient.post(getPath({ facultyId }), data);
// };

export const postFacultyImage = (facultyId: string) =>
  function uploadFileAPI(
    file: File,
    progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
    cancelToken?: CancelToken,
  ): Promise<IPostFacultyImage["response"]> {
    const data = new FormData();

    data.append("image", file);

    return axiosClient.post(getPath({ facultyId }), data, {
      onUploadProgress(progressEvent) {
        progressCallBack?.(progressEvent);
      },
      cancelToken,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
